module.exports = __webpack_public_path__ + "static/media/400016_01.5b63c623.png";